<template lang="pug">
  div.uploader
    form(method='post' action='upload-page.php' enctype='multipart/form-data', :style="formStyle")
      input#filesToUpload(name='filesToUpload[]' type='file' multiple='' ref='filesInput')
    slot(name='header' :files='files')
    slot(name='file' v-for='file in files', :fileInfo='file')
      div {{file.name}}

</template>
<script>
import $ from 'jquery'
import _ from 'lodash'

import { upload, createFileInfo, consts } from '@/utils/upload'

export default {
  consts,
  props: {
    inputHidden: {
      type: Boolean,
      required: false,
      default: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      files: []
    }
  },
  mounted () {
    let input = this.$refs.filesInput
    _.merge({
      autoHideFinished: false
    }, this.options)

    $(input).on('change', () => {
      for (var x = 0; x < input.files.length; x++) {
        let file = input.files[x]
        this.addFile(file)
      }
    })
  },
  computed: {
    formStyle () {
      let style = {}
      if (this.inputHidden) {
        style.visibility = 'hidden'
        style.height = 0
      }
      return style
    }
  },
  methods: {
    askFiles () {
      $(this.$refs.filesInput).val('').click()
    },
    removeFile (file) {
      this.files = this.files.filter((f) => f !== file)
    },
    cancelFile (file) {
      file.status = consts.CANCELED
      file.abort && file.abort()
    },
    addFile (file, options = {}) {
      let fileInfo = createFileInfo(file)
      this.files.push(fileInfo)
      upload([fileInfo],
        _.merge({},
          this.options,
          options,
          {
            onFinish: (file) => {
              this.$emit('fileUploaded', {
                result: JSON.parse((file.xhr && file.xhr.responseText) || '').file,
                fileInfo: fileInfo
              })
              if (fileInfo.status === consts.SUCCESS && this.options.autoHideFinished) {
                this.files = this.files.filter((f) => f !== file)
              }
              this.options.onFinish && this.options.onFinish({
                result: JSON.parse((file.xhr && file.xhr.responseText) || '').file,
                fileInfo: fileInfo
              })
              options.onFinish && options.onFinish({
                result: JSON.parse(file.xhr.responseText).file,
                fileInfo: fileInfo
              })
            }
          })
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Uploader.vue?1a9cf370